// extracted by mini-css-extract-plugin
module.exports = {"expandedItem":"svg-logo-module--expandedItem--3RAgs","collapsedItem":"svg-logo-module--collapsedItem--3g8Cz","isCollapsed":"svg-logo-module--isCollapsed--1nDI1"};